import { isPreviousCompanyIndustryIntro } from './landingEditorCompanyIndustryHeroMigration.js';
import type { StaticPageAudience } from '../content/staticPageContent.js';
import { isIndustryPageKey } from '../content/industryPages.js';

// Replace shipped teaser fragments while preserving individually edited introductions.
const previousDefaultIntros = new Set([
  "Sprache, Anerkennung, Start.",
  "Qualifikation, Sprache, Betrieb.",
  "Handel, Beratung, Frische.",
  "Rollen, Sprache, Teamfit.",
  "Von Auswahl bis Ankommen begleitet.",
  "Passende Profile. Klar begleitet.",
  "Für Beratung, Frische und Kundennähe.",
  "Für Service, Küche und verlässliche Teams.",
  "Personal support for language, recognition and your first day at work.",
  "Experience, language and the right employer are reviewed together.",
  "Preparation for retail, consulting and everyday customer contact.",
  "Roles, language level and team fit are clarified from the beginning.",
  "Structured support from selection through arrival in your team.",
  "Suitable profiles, clear process and long-term team fit.",
  "For consulting, fresh departments and close customer contact.",
  "For service, kitchen and reliable operational roles.",
  "Dil, denklik ve ilk iş gününe kadar kişisel destek.",
  "Deneyim, dil ve uygun işletme birlikte değerlendirilir.",
  "Mağaza, danışmanlık ve günlük iletişim için hazırlık.",
  "Rol, dil seviyesi ve ekip uyumu baştan netleşir.",
  "Seçimden ekibe uyuma kadar yapılandırılmış destek.",
  "Uygun profiller, net süreç ve uzun vadeli ekip uyumu.",
  "Danışmanlık, taze ürün alanları ve müşteri yakınlığı için.",
  "Servis, mutfak ve güvenilir operasyonel roller için.",
]);

export const industryHeroIntro = (
  pageKey: string,
  intro: string,
  defaultIntro: string,
  contentRevision: number,
  audience?: StaticPageAudience,
): string =>
  ((contentRevision < 25 && isIndustryPageKey(pageKey) && previousDefaultIntros.has(intro)) ||
    (contentRevision < 26 && audience === 'company' && isPreviousCompanyIndustryIntro(pageKey, intro)))
    ? defaultIntro
    : intro;
